import { render, staticRenderFns } from "./PolizaAccidentes.vue?vue&type=template&id=9f06eabc&scoped=true&"
import script from "./PolizaAccidentes.vue?vue&type=script&lang=js&"
export * from "./PolizaAccidentes.vue?vue&type=script&lang=js&"
import style0 from "./PolizaAccidentes.vue?vue&type=style&index=0&id=9f06eabc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9f06eabc",
  null
  
)

export default component.exports